import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import * as constants from '../constants'

export default class NavDropdownButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ isOpen: !this.state.isOpen })
  }

  handleClickOutside(e) {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({ isOpen: false })
    }
  }

  render() {
    const { isOpen } = this.state

    return (
      <li
        ref={(node) => {
          this.node = node
        }}
        className={isOpen ? 'open' : ''}>
        <a
          href="#pablo"
          className="dropdown-toggle"
          onClick={this.handleClick}
          aria-expanded={isOpen}>
          <i className="material-icons">{this.props.icon}</i>
          {this.props.badge !== 0 && (
            <span className="notification">{this.props.badge}</span>
          )}
          <p className="hidden-lg hidden-md">{this.props.label}</p>
        </a>
        <ul
          className={`dropdown-menu ${isOpen ? 'show' : ''}`}
          style={{ minWidth: 310 }}>
          {this.props.isUser && (
            <li>
              <h6 className="text-center">{constants.getUserName()}</h6>
              <h6 className="text-center" style={{ fontWeight: 'bold' }}>
                {constants.getUserRole().roleName}
              </h6>
            </li>
          )}
          {constants.haveRole(1) && (
            <li>
              <Link to="/logs" onClick={() => this.setState({ isOpen: false })}>
                Gerar relatório de atividades
              </Link>
            </li>
          )}
          {constants.haveRole(1) && (
            <li>
              <Link
                to="/recibodeatestodeservico"
                onClick={() => this.setState({ isOpen: false })}>
                Gerar recibo de atesto de serviço
              </Link>
            </li>
          )}
          {constants.haveRole(1) && (
            <li>
              <Link
                to="/relatoriorecibos"
                onClick={() => this.setState({ isOpen: false })}>
                Histórico de serviços realizados
              </Link>
            </li>
          )}
          {this.props.links.map((link, key) => {
            return (
              <li key={key}>
                <Link
                  to={link.link}
                  onClick={() => this.setState({ isOpen: false })}>
                  {link.label}
                </Link>
              </li>
            )
          })}
        </ul>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NavDropdownButton.js